import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW4300Component } from './kymw4300.component';
import { KYMW0400Module } from '../../../commons/kymw04/kymw0400/kymw0400.module';
import { OutputGoodsDnaListService } from './api-services/output-goods-dna-list.service';
import { OutputPlanGoodsDnaListService } from './api-services/output-plan-goods-dna-list.service';

/**
 * 商品ＤＮＡ情報一覧画面 モジュール設定クラス
 *
 * @export KYMW4300Module
 * @class KYMW4300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjGridModule,
    KYMW0400Module,
  ],
  declarations: [
    KYMW4300Component,
  ],
  providers: [
    OutputGoodsDnaListService,
    OutputPlanGoodsDnaListService,
  ],
})
export class KYMW4300Module {

}
